// extracted by mini-css-extract-plugin
export default {"bannerTextBox":"style_bannerTextBox__lnq-S","bannerTextBox__item":"style_bannerTextBox__item__rpgua"};